import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=73c8518e&scoped=true&lang=pug&"
import script from "./SelectButtons.vue?vue&type=script&lang=js&"
export * from "./SelectButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectButtons.vue?vue&type=style&index=0&id=73c8518e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8518e",
  null
  
)

component.options.__file = "SelectButtons.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VLayout,
})
